import moment from 'moment'
import {
  calculCycle,
  calculTotalBillard,
  calculTotalConsos
} from 'utils/PriceCalculHelpers'

export function createNewTransactionForBar(bar, hbUser, zDate, customerId) {
  const now = moment().format()
  return {
    zDate: moment(zDate).format('YYYY-MM-DD'),
    isSided: false,
    createdBy: hbUser.key,
    updatedBy: hbUser.key,
    updatedAt: now,
    createdAt: now,
    customer_id: customerId || null,
    type: 'BAR',
    total: 0,
    bar: bar,
    products: []
  }
}
export function createNewTransactionForPool(
  table,
  pricing,
  players,
  hbUser,
  dayStart,
  customerId
) {
  const mom = moment()
  if (__DEV__) mom.subtract(1, 'hours')
  const now = mom.format()
  let playersCount = 0
  players.map(p => {
    playersCount += p.count
    return null
  })
  return {
    zDate: moment(dayStart).format('YYYY-MM-DD'),
    isSided: true,
    createdBy: hbUser.key,
    updatedBy: hbUser.key,
    updatedAt: now,
    createdAt: now,
    customer_id: customerId || null,
    type: 'POOL',
    total: 0,
    pool: {
      table: table,
      total: 0,
      cycles: [
        {
          key: 0,
          startDate: now,
          breakPeriod: 0,
          playersCount: playersCount,
          players: players,
          tableType: table.type,
          total: 0,
          pricing: {
            key: pricing.key,
            name: pricing.name,
            type: pricing.type,
            value: pricing[table.type]
          }
        }
      ]
    },
    products: []
  }
}
function calculMinStartDate(c) {
  return moment(c.endDate)
    .substract(Number(c.breakPeriod) + 1000, 'ms')
    .format()
}
function calculMinEndDate(c) {
  return moment(c.startDate)
    .add(Number(c.breakPeriod) + 1000, 'ms')
    .format()
}
export function addCycle(transaction, pricing) {
  const cycles = [...transaction.pool.cycles]
  const currentCycle = cycles[cycles.length - 1]
  const now = moment().format()
  const newCycle = {
    key: currentCycle.key + 1,
    startDate: now,
    breakPeriod: 0,
    playersCount: currentCycle.playersCount,
    players: currentCycle.players,
    tableType: transaction.pool.table.type,
    total: 0,
    pricing: {
      key: pricing.key,
      name: pricing.name,
      type: pricing.type,
      value: pricing[transaction.pool.table.type]
    }
  }
  currentCycle.endDate = now
  const totals = calculCycle(currentCycle)
  currentCycle.elapsed = totals.elapsed
  currentCycle.total = totals.total
  currentCycle.breakPeriod = totals.breakPeriod
  cycles.push(newCycle)
  return cycles
}
export function deleteCycle(cycles, cycle) {
  if (cycles.length < 2) {
    return cycles
  } else if (cycle.key === 0) {
    cycles.splice(0, 1)
  } else if (cycle.key === cycles.length - 1) {
    cycles[cycle.key - 1].endDate = null
    cycles[cycle.key - 1].elapsed = null
    cycles[cycle.key - 1].total = 0
    cycles.splice(cycle.key, 1)
  } else {
    cycles[cycle.key - 1].endDate = cycles[cycle.key + 1].startDate
    cycles[cycle.key - 1].elapsed = null
    cycles[cycle.key - 1].total = 0
    cycles.splice(cycle.key, 1)
  }
  for (let i = 0; i < cycles.length; i++) {
    cycles[i].key = i
  }
  return editCycle(cycles, cycles[0])
}
export function editCycle(cycles, cycle) {
  cycles[cycle.key] = cycle
  const cyclesCount = cycles.lenght
  let nextStartDate
  let nextEndDate
  for (let i = cycle.key; i >= 0; i--) {
    const c = cycles[i]
    let totals = calculCycle(c)
    if (i === cycle.key) {
      nextEndDate = c.startDate
      c.elapsed = totals.elapsed
      c.total = totals.total
      c.breakPeriod = totals.breakPeriod
      continue
    }
    c.endDate = nextEndDate

    if (totals.elapsed <= 0) {
      c.startDate = calculMinStartDate(c)
      totals = calculCycle(c)
    }
    c.elapsed = totals.elapsed
    c.total = totals.total
    c.breakPeriod = totals.breakPeriod
    nextEndDate = c.startDate
  }
  for (let i = cycle.key; i < cyclesCount; i++) {
    const c = cycles[i]
    let totals = calculCycle(c)
    if (i === cycle.key) {
      nextStartDate = c.endDate
      c.elapsed = totals.elapsed
      c.total = totals.total
      c.breakPeriod = totals.breakPeriod
      continue
    }
    c.startDate = nextStartDate

    if (totals.elapsed <= 0) {
      c.endDate = calculMinEndDate(c)
      totals = calculCycle(c)
    }
    c.elapsed = totals.elapsed
    c.total = totals.total
    c.breakPeriod = totals.breakPeriod
    nextStartDate = c.endDate
  }

  return cycles
}

export function prepareTransactionForPayment(transaction) {
  if (transaction.type === 'POOL') {
    let totalBillard = calculTotalBillard(transaction)
    const totalConsos = calculTotalConsos(transaction)
    return {
      pool: {
        ...transaction.pool,
        totalBillard: totalBillard,
        isPaused: true,
        pauseDate:
          transaction.pool.pauseDate === void 0
            ? moment().format()
            : transaction.pool.pauseDate
      },
      totalConsos: totalConsos,
      total: totalBillard + totalConsos
    }
  } else if (transaction.type === 'BAR') {
    let totalBillard = 0
    const totalConsos = calculTotalConsos(transaction)
    totalBillard +=
      transaction.pool !== void 0 ? transaction.pool.totalBillard : 0
    return {
      totalConsos: totalConsos,
      total: totalBillard + totalConsos
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/helpers/transactionHelpers.js